function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { getDocument } from 'pdfjs-dist';
import { asyncToGenerator as _asyncToGenerator } from "../../_virtual/_rollupPluginBabelHelpers.js";
import { useState, useCallback } from 'react';
import useDocumentsAppConfigs from "../useDocumentsAppConfigs.js";
import join from 'url-join';

var usePdfFile = function usePdfFile() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref3$getFileApi = _ref3.getFileApi,
      getFileApi = _ref3$getFileApi === void 0 ? getDocument : _ref3$getFileApi,
      _ref3$loading = _ref3.loading,
      defaultLoading = _ref3$loading === void 0 ? false : _ref3$loading;

  var _useDocumentsAppConfi = useDocumentsAppConfigs(),
      defaultApiPrefix = _useDocumentsAppConfi.apiPrefix;

  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      error = _useState2[0],
      setError = _useState2[1];

  var _useState3 = useState(null),
      _useState4 = _slicedToArray(_useState3, 2),
      file = _useState4[0],
      setFile = _useState4[1];

  var _useState5 = useState(defaultLoading),
      _useState6 = _slicedToArray(_useState5, 2),
      loading = _useState6[0],
      setLoading = _useState6[1];

  var getPdfFile = useCallback(
  /*#__PURE__*/
  function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var url, apiPrefixOverride, apiPrefix, fileResponse;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              url = _ref.url, apiPrefixOverride = _ref.apiPrefixOverride;
              apiPrefix = apiPrefixOverride || defaultApiPrefix;
              setLoading(true);
              _context.prev = 3;
              _context.next = 6;
              return getFileApi(join(apiPrefix, url)).promise;

            case 6:
              fileResponse = _context.sent;
              setFile(fileResponse);
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context["catch"](3);
              setError(_context.t0);

            case 13:
              setLoading(false);

            case 14:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 10]]);
    }));

    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }(), [defaultApiPrefix, getFileApi]);
  return {
    error: error,
    file: file,
    getPdfFile: getPdfFile,
    loading: loading
  };
};

export default usePdfFile;